// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AqIzg","top":"styles_top__1L9FJ","left":"styles_left__2fTRK","description":"styles_description__VdFYL"};